/* global localStorage */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStorage = require('../base-storage');
var localStorageCleaner = require('../utils/local-storage-cleaner');

var _require = require('../utils/constants'),
    STORAGE_PREFIX = _require.STORAGE_PREFIX,
    PREFIX_SEPARATOR = _require.PREFIX_SEPARATOR,
    KEY_SEPARATOR = _require.KEY_SEPARATOR,
    NOT_FOUND = _require.NOT_FOUND;

var _require2 = require('../utils/record-utils'),
    getCacheRecords = _require2.getCacheRecords,
    deserializeData = _require2.deserializeData,
    isExpired = _require2.isExpired;

function getCacheKey(key, options) {
  return getCachePrefix(options) + key;
}

function getCachePrefix(options) {
  return [STORAGE_PREFIX, options.namespace, options.scope].filter(function (x) {
    return x;
  }).join(PREFIX_SEPARATOR) + KEY_SEPARATOR;
}

function serializeData(value, options) {
  return JSON.stringify({
    lastUsed: Date.now(),
    createdAt: options.createdAt || Date.now(),
    expiration: options.expiration,
    value: value
  });
}

function updateAccessTime(fullKey, data) {
  var expiration = data.expiration,
      createdAt = data.createdAt;

  localStorage.setItem(fullKey, serializeData(data.value, { expiration: expiration, createdAt: createdAt }));
}

var LocalStorageStrategy = function (_BaseStorage) {
  _inherits(LocalStorageStrategy, _BaseStorage);

  function LocalStorageStrategy() {
    _classCallCheck(this, LocalStorageStrategy);

    return _possibleConstructorReturn(this, (LocalStorageStrategy.__proto__ || Object.getPrototypeOf(LocalStorageStrategy)).apply(this, arguments));
  }

  _createClass(LocalStorageStrategy, [{
    key: 'setItem',
    value: function setItem(key, value, options) {
      key = getCacheKey(key, options);
      value = serializeData(value, options);
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        localStorageCleaner(key.length + value.length);
        localStorage.setItem(key, value);
      }
      return Promise.resolve();
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var fullKey = getCacheKey(key, options);
      var data = localStorage.getItem(fullKey);
      data = data && deserializeData(data);
      if (data && !isExpired(data)) {
        updateAccessTime(fullKey, data);
        return Promise.resolve(data.value);
      } else {
        return Promise.reject(NOT_FOUND);
      }
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      key = getCacheKey(key, options);
      localStorage.removeItem(key);
      return Promise.resolve();
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var prefix = getCachePrefix(options);
      var items = {};
      getCacheRecords(prefix).forEach(function (record) {
        if (!isExpired(record)) {
          items[record.key] = record.value;
        }
      });
      return Promise.resolve(items);
    }
  }]);

  return LocalStorageStrategy;
}(BaseStorage);

module.exports = LocalStorageStrategy;